// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"74383653","170":"7d3e6c08","244":"3092ee40","664":"d98ff354"}[chunkId] + ".chunk.js";
};